import { Alert, Container, Snackbar } from '@mui/material';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { useFeedbackContext } from '../context/FeedbackContext';
import { BookmarksGrid } from './BookmarksGrid';
import { Header } from './Header';
import Login from './Login';
import { Share } from './Share';
import Token from './Token';
import { UserState, useUserContext } from '../context/UserContext';

const Stashsite: React.FC = () => {
  // context  
  const { message, messageType, clearMessage } = useFeedbackContext();
  const { userState } = useUserContext();

  return (

    <Container
      sx={{ pt: 0, pb: 2 }}
      maxWidth='lg'>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={userState === UserState.NO_REFRESH_TOKEN ? <Navigate to="/login" replace /> : <BookmarksGrid />} />
          <Route path="/share" element={userState === UserState.NO_REFRESH_TOKEN ? <Navigate to="/share" replace /> : <Share />} />

          <Route path="/login" element={userState === UserState.LOGGED_IN ? <Navigate to="/" replace /> : <Login />} />
          <Route path="/token" element={<Token />} />

          <Route path="/modify/:fid" element={<BookmarksGrid dialog='modify' />} />
          <Route path="/about" element={<BookmarksGrid dialog='about' />} />
          <Route path="/pocket" element={<BookmarksGrid dialog='pocket' />} />
        </Routes>
      </BrowserRouter>

      {/* Generic error and info feedback toast */}
      <Snackbar
        open={!!message}
        autoHideDuration={messageType === 'error' ? 20000 : 5000}
        onClose={clearMessage}
      >
        <Alert severity={messageType} sx={{ width: '100%' }} onClose={clearMessage}>{message}</Alert>
      </Snackbar>

    </Container>

  );
};

export default Stashsite;
